<template>
  <div
    class="info-container"
    id="delivery-modal"
    :class="{ open: deliveryModal }"
    @click.stop.prevent="onClose"
    ref="delivery-modal"
  >
    <div class="info-content">
      <div class="info-close-modal">
        <i class="fa fa-times"></i>
      </div>
      <div class="row">
        <!-- <h2 class="bold text-center">
          {{ $t('deliveryPage.deliveryHeader') }}
        </h2>
        <div v-html="$t('deliveryPage.first')"></div> -->
        <!-- <div class="col-md-12"> -->
        <div class="h2 text-center">Методи оплати</div>
        <ul
          id="seasidetms_icon_list_items_v80addeibn"
          class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
        >
          <li
            id="seasidetms_icon_list_item_313kuc2855"
            class="seasidetms_icon_list_item shortcode_animated"
          >
            <div class="seasidetms_icon_list_item_inner">
              <div class="seasidetms_icon_list_icon_wrap">
                <span
                  id="send-money"
                  class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
                ></span>
              </div>
              <div class="seasidetms_icon_list_item_content">
                <div class="h3 seasidetms_icon_list_item_title">Розстрочка</div>
                <div class="seasidetms_icon_list_item_text">
                  <p>Розрахунок переказом (МоноБанк,ПриватБанк та інші);</p>
                </div>
              </div>
            </div>
          </li>
          <li
            id="seasidetms_icon_list_item_313kuc2855"
            class="seasidetms_icon_list_item shortcode_animated"
          >
            <div class="seasidetms_icon_list_item_inner">
              <div class="seasidetms_icon_list_icon_wrap">
                <span
                  id="pos"
                  class="seasidetms_icon_list_icon seasidetms-icon-basket-3"
                ></span>
              </div>
              <div class="seasidetms_icon_list_item_content">
                <div class="h3 seasidetms_icon_list_item_title">Терінал</div>
                <div class="seasidetms_icon_list_item_text">
                  <p>
                    Розрахунок через термінал у фізичних магазинах(враховується
                    комісія 2%);
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul
          id="seasidetms_icon_list_items_v80addeibn"
          class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
        >
          <li
            id="seasidetms_icon_list_item_313kuc2855"
            class="seasidetms_icon_list_item shortcode_animated"
          >
            <div class="seasidetms_icon_list_item_inner">
              <div class="seasidetms_icon_list_icon_wrap">
                <span
                  id="online-payment"
                  class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
                ></span>
              </div>
              <div class="seasidetms_icon_list_item_content">
                <div class="h3 seasidetms_icon_list_item_title">
                  Онлайн оплата
                </div>
                <div class="seasidetms_icon_list_item_text">
                  <p>Розрахунок онлайн сервісом fondy;</p>
                </div>
              </div>
            </div>
          </li>
          <li
            id="seasidetms_icon_list_item_313kuc2855"
            class="seasidetms_icon_list_item shortcode_animated"
          >
            <div class="seasidetms_icon_list_item_inner">
              <div class="seasidetms_icon_list_icon_wrap">
                <span
                  id="cash"
                  class="seasidetms_icon_list_icon seasidetms-icon-basket-3"
                ></span>
              </div>
              <div class="seasidetms_icon_list_item_content">
                <div class="h3 seasidetms_icon_list_item_title">
                  Оплата готівкою
                </div>
                <div class="seasidetms_icon_list_item_text">
                  <p>Розрахунок готівкою у фізичних магазинах</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <div class="h2 text-center col-md-12">Варіанти оплати та доставки</div>
        <ul
          id="seasidetms_icon_list_items_v80addeibn"
          class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
        >
          <li
            id="seasidetms_icon_list_item_313kuc2855"
            class="seasidetms_icon_list_item shortcode_animated"
          >
            <div class="seasidetms_icon_list_item_inner">
              <div class="seasidetms_icon_list_icon_wrap">
                <span
                  id="post-office"
                  class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
                ></span>
              </div>
              <div class="seasidetms_icon_list_item_content">
                <div class="h3 seasidetms_icon_list_item_title">
                  Накладений платіж
                </div>
                <div class="seasidetms_icon_list_item_text">
                  <p>
                    Для цього варіанту потрібна <b>передплата - 300 грн</b> (для
                    підтвердження замовлення) <br />
                    — Передплату <b>ВІДНІМАЄМО</b> від загальної вартості
                    замовлення!
                    <br />
                    — Передплату <b>ПОВЕРТАЄМО</b> - якщо замовлення не
                    підійшло!
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <ul
          id="seasidetms_icon_list_items_v80addeibn"
          class="col-md-6 seasidetms_icon_list_items seasidetms_icon_list_type_block seasidetms_icon_list_pos_left seasidetms_color_type_icon"
        >
          <li
            id="seasidetms_icon_list_item_313kuc2855"
            class="seasidetms_icon_list_item shortcode_animated"
          >
            <div class="seasidetms_icon_list_item_inner">
              <div class="seasidetms_icon_list_icon_wrap">
                <span
                  id="credit-card"
                  class="seasidetms_icon_list_icon seasidetms-icon-desktop-4"
                ></span>
              </div>
              <div class="seasidetms_icon_list_item_content">
                <div class="h3 seasidetms_icon_list_item_title">
                  Повна оплата
                </div>
                <div class="seasidetms_icon_list_item_text">
                  <p>
                    У цьому варіанті магазин сплачує усі послуги пошти
                    (доставка, пакування) Перевага цього варіанту у тому, що Ви
                    <b>зекономите 2%</b> від вартості товару (комісія Нової
                    пошти), тобто Вам потрібно лише сплатити вартість замовлення
                    та забрати його з пошти!
                  </p>
                </div>
              </div>
            </div>
          </li>
        </ul>
        <!-- </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'DeliveryModal',
  computed: {
    ...mapState(['deliveryModal']),
  },
  methods: {
    onClose() {
      this.$store.commit('setDeliveryModal', null)
    },
  },
}
</script>

<style>
#seasidetms_icon_list_items_v80addeibn .seasidetms_icon_list_icon {
  width: 80px;
  height: 80px;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
.seasidetms_icon_list_items
  .seasidetms_icon_list_item
  .seasidetms_icon_list_icon:after {
  border-width: unset !important;
  border-style: unset !important;
}
#delivery-modal {
  display: none;
}
.open {
  display: flex !important;
}
@media only screen and (max-width: 768px) {
  #delivery-modal .info-content {
    height: 100vh;
    overflow: scroll;
  }
}

#send-money::before {
  content: '' !important;
  background-image: url(/img/send-money.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
#pos::before {
  content: '' !important;
  background-image: url(/img/pos.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
#online-payment::before {
  content: '' !important;
  background-image: url(/img/online-payment.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
#cash::before {
  content: '' !important;
  background-image: url(/img/cash.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
#post-office::before {
  content: '' !important;
  background-image: url(/img/post-office.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
#credit-card::before {
  content: '' !important;
  background-image: url(/img/credit-card.svg);
  height: 35px;
  width: 35px;
  background-size: 35px;
  background-repeat: no-repeat;
  margin-top: 20px;
}
</style>
